// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8f3fbe3","455":"e123091f","977":"d31418d2"}[chunkId] + ".chunk.js";
};